import PropTypes from 'prop-types';

const HiddenField = ({ input }) => {
  const { name } = input;
  return <input {...input} type="hidden" id={name} />;
};

HiddenField.propTypes = {
  input: PropTypes.object.isRequired,
};

export default HiddenField;
